import BodyCard from "../../components/BodyCard";
import Section from "../../components/Section";
import OngoingResearchContent from "../../components/OngoingResearch";

export default function OngoingResearch() {
  return (
    <BodyCard>
      <Section noDivider content={<OngoingResearchContent />} />
    </BodyCard>
  );
}
